(function () {
  'use strict';

  var ROTATE_MS = 4500;
  var SWIPE_PX = 40;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var init = function (root) {
    var track = root.querySelector('[data-sp-calc-show-track]');
    if (!track || track.hasAttribute('data-sp-calc-show-ready')) return;
    track.setAttribute('data-sp-calc-show-ready', '');
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    var current = 0;
    var show = function (i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === current;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    };

    var timer = null;
    var hovered = false, focused = false, visible = true;
    var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
    var start = function () {
      stop();
      if (reduce || hovered || focused || !visible || document.hidden) return;
      timer = setInterval(function () { show(current + 1); }, ROTATE_MS);
    };

    // Hover and focus pause ONLY for a real mouse and for keyboard focus. A phone tap fires a
    // compatibility mouseenter with no mouseleave, and focuses the tabindex track, so the old
    // 0,0,0,0,0,0 over 12s after a tap, 0,1,1,1,2,2 without one).
    root.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      hovered = true; stop();
    });
    root.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      hovered = false; start();
    });
    track.addEventListener('focus', function () {
      if (track.matches && !track.matches(':focus-visible')) return;
      focused = true; stop();
    });
    track.addEventListener('blur', function () {
      if (!focused) return;
      focused = false; start();
    });
    document.addEventListener('visibilitychange', start);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[es.length - 1].isIntersecting;
        start();
      }, { threshold: 0.25 }).observe(root);
    }

    // Touch swipe. Pointer events cover touch and pen; a mouse drag is ignored
    // (desktop has no controls by request). The page's vertical scroll is left
    // to the browser by touch-action: pan-y.
    var x0 = null, y0 = null;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      x0 = e.clientX; y0 = e.clientY;
    }, { passive: true });
    track.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = y0 = null;
      if (Math.abs(dx) < SWIPE_PX || Math.abs(dx) < Math.abs(dy)) return;
      show(current + (dx < 0 ? 1 : -1));
      start();
    }, { passive: true });
    track.addEventListener('pointercancel', function () { x0 = y0 = null; });

    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      show(current + (e.key === 'ArrowRight' ? 1 : -1));
    });

    show(0);
    start();
  };

  var boot = function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sp-calc-show]'), init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-sp-calc-show]'), init);
  });
})();
